import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Link,
  Text,
  useColorModeValue
} from '@chakra-ui/react';
import IconBox from 'components/Icons/IconBox';
import { Separator } from 'components/Separator/Separator';
import { NavLink, useLocation } from 'react-router-dom';
import textura from '../../assets/img/textura_3.jpg';
import UsuariosMenuController from 'controllers/Usuarios/UsuariosMenuController';

const SidebarContent = ({ logoText, routes }) => {
  const background = useColorModeValue('brand.900', 'gray.600');
  const foreground = useColorModeValue('white', 'gray.400');

  let location = useLocation();
  const [state, setState] = useState({});
  const [menuPaths, setMenuPaths] = useState([]);

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? 'active' : '';
  };

  const createLinks = (routes) => {
    const buttonBgOnHover = useColorModeValue('brand.600', '#c4c4c43d');
    const activeIconBg = useColorModeValue('brand.700', '#9e9e9e5c');
    const inactiveIconBg = useColorModeValue('brand.600', 'gray.700');
    const inactiveIconColor = useColorModeValue('white', 'gray.400');
    const iconColorOnHover = useColorModeValue('gray.100', 'white');

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await UsuariosMenuController.ListMenus();
          console.log(response);
          const paths = response.result.map(menu => menu.menu_path);
          setMenuPaths(paths);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      fetchData();
    }, []);

    return routes.map((prop, key) => {
      if (!prop.path) {
        return (
          <Heading as="h3" size="md" paddingX={6} paddingY={4} color={foreground} key={key}>
            {prop}
          </Heading>
        );
      }

      if (prop.redirect || !menuPaths.includes(prop.path)) {
        return null;
      }
      if (prop.category) {
        var st = {};
        st[prop['state']] = !state[prop.state];
        return (
          <div key={prop.name}>
            <Text
              color={foreground}
              fontWeight="bold"
              mb={{ xl: '12px' }}
              mx="auto"
              ps={{ sm: '10px', xl: '16px' }}
              py="12px"
            >
              {document.documentElement.dir === 'rtl' ? prop.rtlName : prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      return (
        <NavLink to={prop.layout + (prop.path === '/Dashboard' ? menuPaths[0] : prop.path)} key={prop.name}>
          {activeRoute(prop.layout + prop.path) === 'active' ? (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg={background}
              mb={{ xl: '12px' }}
              mx={{ xl: 'auto' }}
              ps={{ sm: '10px', xl: '16px' }}
              py="8px"
              borderRadius="55px"
              _hover="none"
              w="100%"
              _active={{
                bg: buttonBgOnHover,
                transform: 'none',
                borderColor: 'transparent',
              }}
              _focus={{ boxShadow: 'none' }}
            >
              <Flex>
                {typeof prop.icon === 'string' ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                  <IconBox bg={activeIconBg} color="white" h="30px" w="30px" me="8px">
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={foreground} my="auto" fontSize="sm">
                  {document.documentElement.dir === 'rtl' ? prop.rtlName : prop.name}
                </Text>
              </Flex>
            </Button>
          ) : (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg="transparent"
              mb={{ xl: '12px' }}
              mx={{ xl: 'auto' }}
              py="3px"
              ps={{ sm: '10px', xl: '16px', color: iconColorOnHover }}
              borderRadius="55px"
              color={inactiveIconColor}
              _hover={{
                bg: buttonBgOnHover,
                transform: 'none',
              }}
              w="100%"
              _active={{
                bg: 'inherit',
                transform: 'none',
                borderColor: 'transparent',
              }}
              _focus={{ boxShadow: 'none' }}
            >
              <Flex>
                {typeof prop.icon === 'string' ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                  <IconBox bg={inactiveIconBg} h="20px" w="20px" me="8px">
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={foreground} my="auto" fontSize="xs">
                  {document.documentElement.dir === 'rtl' ? prop.rtlName : prop.name}
                </Text>
              </Flex>
            </Button>
          )}
        </NavLink>
      );
    });
  };

  const links = <>{createLinks(routes)}</>;

  return (
    <>
      <Box pt={'25px'} mb="12px">
        <Link
          href={`${process.env.PUBLIC_URL}/#/`}
          target="_blank"
          display="flex"
          lineHeight="100%"
          mb="30px"
          fontWeight="bold"
          fontSize="11px"
        >
          <Heading size="lg" mt="3px" color={foreground}>
            {logoText}
          </Heading>
        </Link>
        <Separator />
      </Box>
      <Box
        position="relative"
        maxHeight="calc(90vh - 90px)"
        overflowY="auto"
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="cover"
        sx={{
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${textura})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            opacity: 0.1,
          },
        }}
      >
        {links}
      </Box>
    </>
  );
};

export default SidebarContent;